var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragdrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dragdrop-major-svgrepo-com",
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.98,
    height: 33.98,
    viewBox: "0 0 33.98 33.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7247",
    "data-name": "Path 7247",
    d: "M3.4,3.4H5.1V0H2.549A2.549,2.549,0,0,0,0,2.549V5.1H3.4Zm5.1,0h5.1V0H8.5Zm13.593,0h-5.1V0h5.1ZM0,8.5v5.1H3.4V8.5Zm0,8.5v5.1H3.4v-5.1ZM30.583,8.5h-3.4v5.1h3.4ZM8.5,30.583h5.1v-3.4H8.5ZM0,28.884a1.7,1.7,0,0,0,1.7,1.7H5.1v-3.4H3.4v-1.7H0ZM27.185,5.1V3.4h-1.7V0h2.549a2.549,2.549,0,0,1,2.549,2.549V5.1Z",
    transform: "translate(0)",
    fill: "#02529c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7248",
    "data-name": "Path 7248",
    d: "M15.577,20.991H6.549A2.549,2.549,0,0,1,4,18.442V6.549A2.549,2.549,0,0,1,6.549,4H18.442a2.549,2.549,0,0,1,2.549,2.549v9.029l9.365,4.258a1.414,1.414,0,0,1,.048,2.55L25.48,24.849a1.414,1.414,0,0,0-.632.63L22.386,30.4a1.414,1.414,0,0,1-2.55-.048Zm-1.544-3.4L12.626,14.5A1.414,1.414,0,0,1,14.5,12.626l3.094,1.407V7.4H7.4V17.593Z",
    transform: "translate(2.796 2.796)",
    fill: "#02529c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragdrop);
export default __webpack_public_path__ + "static/media/dragdrop.97616fa38c6ac7ebb0ea33dbaef9c429.svg";
export { ForwardRef as ReactComponent };